import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/Assets-V4/Switching/lite-8-poe@2x.jpg.mjs';
import '../../assets/Switching/lite8PoE.jpg.mjs';
import { compact } from '../product-groups/switching/compact.mjs';
import { productListSwitchingCompact } from '../product-list-groups/productListSwitchingCompact.mjs';
import '../properties/index.mjs';
import { switchTechnology } from '../properties/switchTechnology.mjs';
import { portCount } from '../properties/portCount.mjs';
import { ports } from '../properties/ports.mjs';
import { downlinkSpeed } from '../properties/downlinkSpeed.mjs';
import { uplinkSpeed } from '../properties/uplinkSpeed.mjs';
import { poeOutput } from '../properties/poeOutput.mjs';
import { poeAvailability } from '../properties/poeAvailability.mjs';
import { etherlighting } from '../properties/etherlighting.mjs';
import { proAvSupport } from '../properties/proAvSupport.mjs';
import { powerMethod } from '../properties/powerMethod.mjs';
import { mounting } from '../properties/mounting.mjs';
import { outdoorReady } from '../properties/outdoorReady.mjs';
import v3Image__default from "../../../../assets/lite8PoE.jpg";
import image__default from "../../../../assets/lite-8-poe@2x.jpg";
"use strict";
const lite8PoE = {
  id: "lite8PoE",
  productTitle: "Lite 8 PoE",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-lite-8-poe"],
  storePathParts: {
    productSlug: "usw-lite-8-poe",
    category: "switching-utility"
  },
  sku: "USW-Lite-8-PoE",
  description: "lite8PoE.description",
  descriptionMaxWidth: 150,
  image: {
    src: image__default,
    width: 200,
    height: 140
  },
  v3Image: {
    src: v3Image__default,
    width: 230,
    height: 120
  },
  productListGroup: productListSwitchingCompact,
  productGroup: compact,
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: '99.6 x 163.7 x 31.7 mm\n(4 x 6.4 x 1.3")'
    }
  }, {
    propertyId: switchTechnology.id,
    value: {
      type: "translation",
      value: "commons.switchingTechnology.layer2"
    }
  }, {
    propertyId: portCount.id,
    value: {
      type: "string",
      value: "16"
    }
  }, {
    propertyId: portCount.id,
    value: {
      type: "string",
      value: "8"
    }
  }, {
    propertyId: ports.id,
    value: {
      type: "string",
      value: "(8) GbE RJ45"
    }
  }, {
    propertyId: downlinkSpeed.id,
    value: {
      type: "string",
      value: "1 Gbps"
    }
  }, {
    propertyId: uplinkSpeed.id,
    value: {
      type: "string",
      value: "1 Gbps"
    }
  }, {
    propertyId: poeOutput.id,
    value: {
      type: "translation",
      value: "commons.poeOutput.upToPoe+"
    }
  }, {
    propertyId: poeAvailability.id,
    value: {
      type: "string",
      value: "52 W"
    }
  }, {
    propertyId: etherlighting.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: proAvSupport.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "generalRedundancy",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: powerMethod.id,
    value: {
      type: "translation",
      value: "commons.powerMethod.acPower"
    }
  }, {
    propertyId: mounting.id,
    value: {
      type: "translation",
      value: "commons.mounting.desktopWall"
    }
  }, {
    propertyId: outdoorReady.id,
    value: {
      type: "boolean",
      value: false
    }
  }]
};
export { lite8PoE };
//# sourceMappingURL=lite8PoE.mjs.map
